import { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import {
  useCompleteBookingDetailMutation,
  useFindByBookingIdMutation,
  useSaveBookingDetailMutation,
} from "../../redux/services/bookingApi";
import { useSaveAuditLogMutation } from "../../redux/services/calculateBillingRateService";
import { useAppSelector } from "../../redux/app/hooks";
import RegularModal from "../../components/Modals/RegularModal";
import { formatDateTime, roundNumber } from "../../redux/services/utility";
import RegularButton from "../../components/Buttons/RegularButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useExportToPDFMutation } from "../../redux/services/qrCodePdfDownloadApi";
import MuiAlert from "../MuiAlert/MuiAlert";
import { resetCartData } from "../../redux/slices/cartSlice";
import { useDispatch } from "react-redux";
function PaymentSuccess() {
  const location: any = useLocation();
  let payment = new URLSearchParams(window.location.search).get("Payment");
  const navigate = useNavigate();
  const [saveBookingDetail, saveBookingDetailResponse] =
    useSaveBookingDetailMutation();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const [auditLog, auditLogResponse] = useSaveAuditLogMutation();
  const [cashbackSucess, setCashbackSuccess] = useState(false);
  const [bookingPayload, setBookingPayload] = useState({});
  const [qrCodePDFDownload, qrCodePDFDownloadResponse] =
    useExportToPDFMutation();
  const BookingDetail: any = JSON.parse(
    localStorage.getItem("bookingDetail") || "{}"
  );
  const customerDetail: any = JSON.parse(
    localStorage.getItem("customerDetail") || "{}"
  );
  const orderId: any = JSON.parse(localStorage.getItem("orderId") || "{}");
  const lat: any = JSON.parse(localStorage.getItem("lat") || "{}");
  const lng: any = JSON.parse(localStorage.getItem("lng") || "{}");
  const [findBookingId, bookingIdResponse] = useFindByBookingIdMutation();
  const [bookingSuccessData, setBookingSuccessData] = useState([]) as any;
  const cartId: any =
    localStorage.getItem("cartId") !== "null"
      ? localStorage.getItem("cartId")
      : null;
  const value = JSON.parse(localStorage.getItem("extraPaymentBooking") || "{}");
  const [completeBookingDetail, completeBookingDetailResponse] =
    useCompleteBookingDetailMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (payment == "Payment") {
      let isLoggedIn: any = localStorage.getItem("isLoggedIn");
      isLoggedIn = JSON.parse(isLoggedIn);
    }
  }, []);

  const handleDownloadQRcode = (bookingSuccessData: any) => {
    qrCodePDFDownload({
      token: token,
      bookingId: bookingSuccessData.id,
      bookingCode: bookingSuccessData.bookingCode,
      flag: "CHECKINCHECKOUT",
      subBookingId:
        bookingSuccessData &&
        bookingSuccessData.subBookingDetailList &&
        bookingSuccessData.subBookingDetailList[0].id,
    });
  };

  useEffect(() => {
    if (payment == "Payment") {
      const cartId: any =
        localStorage.getItem("cartId") !== "null"
          ? localStorage.getItem("cartId")
          : null;
      let payload = {
        bookingAmount: BookingDetail?.ammount,
        bookingDate: BookingDetail?.bookingDate,
        cardAmount: BookingDetail?.finalAmount,
        cartId: cartId,
        checkinTime: BookingDetail?.checkinTime,
        checkoutTime: BookingDetail?.checkoutTime,
        parkingCategoryId: BookingDetail?.parkingCategoryId,
        convenienceFee: BookingDetail?.convenienceFee,
        fixedFee: BookingDetail?.fixedFee,
        invoiceDate: new Date().toISOString(),
        email: currentUser?.email ? currentUser?.email : customerDetail?.email,
        phoneNo: currentUser?.mobileNo
          ? currentUser?.mobileNo
          : customerDetail?.phoneNo,
        isGuest: false,
        offerDetailId: BookingDetail?.offerDetailId,
        parkingLocationId: BookingDetail?.parkingLocationId,
        rewardGained: BookingDetail?.finalAmount,
        rewardUsed: BookingDetail?.redeemAmount | 0.0,
        serviceProviderId: BookingDetail?.serviceProviderId,
        status: true,
        taxAmount: BookingDetail?.totalTaxAmount,
        totalAmount: BookingDetail?.finalAmount,
        transactionRefId: orderId,
        customerId: currentUser?.customerId
          ? currentUser?.customerId
          : customerDetail?.id,
        countyTax: BookingDetail?.countyTaxAmount,
        salesTax: BookingDetail?.salesTaxAmount,
        stateTax: BookingDetail?.stateTaxAmount,
        userTimezone: BookingDetail?.userTimezone,
        channel: "WEB",
        vehicleNumber: BookingDetail?.vehicleNo,
        isCommercial: BookingDetail?.isCommercial,
        booking: false,
        lat: lat,
        lng: lng,
        invoiceType: "CARD",
        paidBy: "ONLINE",
      };
      saveBookingDetail({
        payload: [payload],
      });
      setBookingPayload(payload);
      auditLog({
        payload: {
          cartId: cartId,
          endTime: new Date(),
          eventName: "WEB",
          request: JSON.stringify(bookingPayload),
          response: "{}",
          serviceName: "NEW_BOOKING_start",
          startTime: new Date(),
          url: "/bookingDetail/save",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (saveBookingDetailResponse.isSuccess) {
      findBookingId({
        token: token,
        id: saveBookingDetailResponse.data[0].id,
      });
      localStorage.removeItem("bookingDetail");
      localStorage.removeItem("orderId");
      localStorage.removeItem("lat");
      localStorage.removeItem("lng");

      setCashbackSuccess(true);
      auditLog({
        payload: {
          cartId: cartId,
          endTime: new Date(),
          eventName: "WEB",
          request: JSON.stringify(bookingPayload),
          response: JSON.stringify(saveBookingDetailResponse),
          serviceName: "NEW_BOOKING",
          startTime: new Date(),
          url: "/bookingDetail/save",
        },
      });
    }
    if (saveBookingDetailResponse.isError) {
      setCashbackSuccess(false);
    }
  }, [saveBookingDetailResponse.isSuccess, saveBookingDetailResponse.isError]);

  useEffect(() => {
    if (bookingIdResponse.isSuccess) {
      setBookingSuccessData(bookingIdResponse.data);
    }
  }, [bookingIdResponse.isSuccess]);

  useEffect(() => {
    if (payment == "ExtraPayment") {
      let payload = {
        extraAmount: value?.extraAmount,
        isGuest: false,
        paidBy: "ONLINE",
        transactionId: orderId,
        bookingId: value?.bookingId,
        subBookingId: value?.subBookingId,
        salesTaxAmount: value?.subBookingId,
        stateTaxAmount: value?.stateTaxAmount,
        countyTaxAmount: value?.countyTaxAmount,
        pendingAmount: value?.pendingAmount,
      };
      completeBookingDetail({
        token: token,
        payload: payload,
      });
      auditLog({
        payload: {
          endTime: new Date(),
          eventName: "WEB",
          request: JSON.stringify(payload),
          response: JSON.stringify(completeBookingDetailResponse),
          serviceName: "EXTRA_PAYMENT_BOOKING_START",
          startTime: new Date(),
          url: "/bookingDetail/complete",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (completeBookingDetailResponse.isError) {
      setStatusCode({ type: "error", code: "PAYMENT_FAILURE" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 10000);
    }
    if (completeBookingDetailResponse.isSuccess) {
      localStorage.removeItem("extraPaymentBooking");
      setStatusCode({ type: "error", code: "PAYMENT_SUCCESS" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 10000);
      navigate("/");
    }
  }, [
    completeBookingDetailResponse.isError,
    completeBookingDetailResponse.isSuccess,
  ]);

  return (
    <div>
      <div className="h-[75px] z-10 fixed mx-10 ">
        <Header position={"fixed"} isLoggedIn={token ? true : false} />
      </div>
      {isAlertVisible && (
        <div>
          <MuiAlert
            severity={statusCode?.type!}
            messageType={statusCode?.code!}
          />
        </div>
      )}
      {cashbackSucess && (
        <RegularModal
          modalDialogStyle="w-[600px] h-[535px] rounded-none"
          visible={cashbackSucess}
          setVisible={setCashbackSuccess}
        >
          <div>
            <div className="bg-slate-200 text-black p-10">
              <div className="flex justify-center flex-col">
                <div className="flex justify-center">
                  <img
                    className="w-[20%] h-[20%]"
                    src={require("../../assets/logo2.png")}
                  />
                </div>
                <div className="flex justify-center items-center m-6">
                  <img
                    className="w-[10%] h-[10%]"
                    src={require("../../assets/success.png")}
                  />
                  <div>
                    <h1 className="font-semibold text-black mt-2 text-2xl">
                      Congratulations
                    </h1>
                    <h4 className="font-medium text-lg w-[]50%">
                      {bookingSuccessData &&
                        bookingSuccessData?.parkingCategoryResDTO?.type == "Pass"
                        ? `You pass is created`
                        : `You have successfully reserved your spot`}
                    </h4>
                  </div>
                </div>
                <div className="flex justify-center m-3">
                  {bookingSuccessData &&
                    bookingSuccessData?.parkingCategoryResDTO?.categoryName ==
                    "Four Wheeler" ? (
                    <img src={require("../../assets/car.png")} />
                  ) : (
                    <img src={require("../../assets/bike.png")} />
                  )}
                </div>
                <div className="flex justify-center flex-col items-center">
                  <p className="font-semibold text-[18px] text-black ">
                    {bookingSuccessData &&
                      bookingSuccessData?.parkingCategoryResDTO
                        ?.categoryName}{" "}
                    {bookingSuccessData?.parkingCategoryResDTO?.type}
                  </p>
                  <p className="rounded-full text-black border-2 mt-2 px-2 bg-white">
                    {bookingSuccessData?.vehicleNumber}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-center gap-3 m-6">
              <div>
                <p className="text-[15px] text-black mb-2">Valid Till:</p>
                <p className="text-[15px] text-black mb-2">Timing Criteria:</p>
                {bookingSuccessData?.parkingCategoryResDTO?.bookingType &&
                  bookingSuccessData?.parkingCategoryResDTO?.bookingType !==
                  null ? (
                  <p className="text-[15px] text-black mb-2">Vehicle Shift:</p>
                ) : null}
                <p className="text-[15px] text-black mb-2">Type of Vehicle:</p>
              </div>
              <div>
                <p className="ml-4 text-black text-[15px] mb-2 font-semibold">
                  {formatDateTime(
                    bookingSuccessData?.checkoutTime,
                    "DD MMM yyyy"
                  )}
                </p>
                <p className="ml-4 text-black text-[15px] mb-2 font-semibold">
                  {bookingSuccessData?.parkingCategoryResDTO?.subCategoryName}
                </p>
                {bookingSuccessData &&
                  bookingSuccessData?.parkingCategoryResDTO?.bookingType !==
                  null ? (
                  <p className="ml-4 text-black text-[15px] mb-2 font-semibold">
                    {bookingSuccessData?.parkingCategoryResDTO?.bookingType}
                  </p>
                ) : null}
                <p className="ml-4 text-black text-[15px] mb-2 font-semibold">
                  {bookingSuccessData?.customerVehicleDetailResDTO
                    ?.isCommercial == "YES"
                    ? "Commercial"
                    : "Private"}
                </p>
              </div>
            </div>
            <div className="items-center m-8 flex justify-center">
              <p className="text-[24px] text-[#475467]">Unique ID :</p>
              <p className="text-[#E23744] text-[24px]">
                {bookingSuccessData?.bookingCode}
              </p>
            </div>
            <div className=" flex flex-col justify-evenly mt-4 md:flex-row">
              <RegularButton
                onClick={() => {
                  localStorage.removeItem("cartId");
                  localStorage.removeItem("bookingDetails");
                  localStorage.removeItem("passengerDetail");
                  localStorage.removeItem("tripDetails");
                  localStorage.removeItem("orderId");
                  localStorage.removeItem("lat");
                  localStorage.removeItem("lng");
                  dispatch(resetCartData());
                  navigate("/");
                }}
                className=" w-full md:w-[40%] p-4 m-2"
                title={"Done! Go home"}
              />
              <RegularButton
                onClick={() => handleDownloadQRcode(bookingSuccessData)}
                className="w-full md:w-[40%] p-4 m-2 "
                title={" Download QR Code"}
              />
            </div>
          </div>
        </RegularModal>
      )}
    </div>
  );
}

export default PaymentSuccess;
